import { z } from 'zod';

export const editUserSchema = z.object({
  firstName: z.string().min(1, 'First name is required'),
  lastName: z.string().min(1, 'Last name is required'),
  phone: z.string().optional(),
  role: z.enum(['ADMIN', 'MANAGER', 'AGENT'] as const),
});

export type EditUserFormData = z.infer<typeof editUserSchema>;
